import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, ChevronDown, MessageCircle, Phone, ArrowRight, Monitor, Tag, Tv, Users, Plane, Scale, LayoutDashboard, BarChart3, Gauge, Briefcase, RefreshCw, Database, ShoppingCart, ShoppingBag, Headphones, Rocket, CreditCard, Wrench, MapPin, Server, Printer, Scan, Cpu, Search, BatteryCharging, Zap, ShieldCheck, Clock, Handshake, Award, Newspaper, DoorOpen, HardHat, Hammer, Smartphone, Shrimp, Package, Calculator, Activity, Sparkles } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { useCart } from '@/components/shared/Cart';
import { resolveIcon } from '@/lib/iconMap';

const WHATSAPP_NUMBER = '56975294340';

// WhatsApp brand icon (solid logo, NOT the generic chat bubble)
const WhatsAppIcon = ({ className = 'w-5 h-5' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    fill="currentColor"
    aria-hidden="true"
    className={className}
  >
    <path d="M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39a.63.63 0 0 1-.315-.1c-.802-.402-1.504-.817-2.163-1.447-.545-.516-1.146-1.29-1.46-1.963a.426.426 0 0 1-.073-.215c0-.33.99-.945.99-1.49 0-.143-.73-2.09-.832-2.335-.143-.372-.214-.487-.6-.487-.187 0-.36-.043-.53-.043-.302 0-.53.115-.746.315-.688.645-1.032 1.318-1.06 2.264v.114c-.015.99.472 1.977 1.017 2.78 1.23 1.82 2.506 3.41 4.554 4.34.616.287 2.035.91 2.722.91.36 0 2.92-.71 2.92-1.967 0-.477-1.5-1.067-1.91-1.067zM16.041 0C7.176 0 0 7.176 0 16.041c0 3.333 1.018 6.43 2.764 8.99L1.143 30l5.158-1.643a16.04 16.04 0 0 0 9.74 3.328C24.864 31.685 32 24.55 32 15.683 32 7.176 24.906 0 16.041 0zm0 28.756c-2.793 0-5.387-.836-7.553-2.276l-5.275 1.685 1.715-5.106a13.27 13.27 0 0 1-2.566-7.85c0-7.378 6.027-13.405 13.405-13.405 7.378 0 13.405 6.027 13.405 13.405.001 7.378-5.752 13.547-13.13 13.547z" />
  </svg>
);

const menuData = {
  soluciones: {
    label: 'Soluciones',
    items: [
      { name: '⭐ Visual Experience (AVX)', href: '/soluciones/visual-experience', icon: Tv, desc: 'NUEVA · LED premium + inteligencia ALLCOM' },
      { name: '1. Autoservicio & Self-Checkout', href: '/soluciones/autoservicio-self-checkout', icon: Monitor, desc: 'Kioscos self-checkout integrados' },
      { name: '2. Máquinas Vending', href: '/soluciones/maquinas-vending', icon: Package, desc: 'Vending inteligente con IoT y pagos digitales' },
      { name: '3. Turnomáticos & Filas', href: '/soluciones/turnomaticos-gestion-filas', icon: Users, desc: 'Gestión de turnos y filas inteligentes' },
      { name: '4. ESL / Precios Digitales', href: '/soluciones/esl-precios-digitales', icon: Tag, desc: 'Etiquetas electrónicas SOLUM' },
      { name: '5. Cartelería Digital', href: '/soluciones/carteleria-digital', icon: Tv, desc: 'Signage premium con gestión centralizada' },
      { name: '6. Gestión de Filas', href: '/soluciones/gestion-filas', icon: Users, desc: 'Turnos y filas inteligentes' },
      { name: '7. Aeropuertos & Alto Tráfico', href: '/soluciones/aeropuertos', icon: Plane, desc: 'Carga y medición aeroportuaria' },
      { name: '8. Balanzas de Pesaje Comercial', href: '/soluciones/balanzas-pesaje-comercial', icon: Scale, desc: 'Balanzas comerciales e industriales' },
      { name: '9. Portillones Automáticos', href: '/soluciones/portillones-automaticos', icon: DoorOpen, desc: 'Portillones inteligentes para retail' },
    ]
  },
  hardware: {
    label: 'Hardware',
    items: [
      { name: '1. Kioscos Autoservicio', href: '/hardware/kioscos-autoservicio', icon: Monitor },
      { name: '2. Puntos de Venta (POS)', href: '/hardware/pos', icon: CreditCard },
      { name: '3. Price Checkers', href: '/hardware/price-checkers', icon: Search },
      { name: '4. Balanzas Comerciales', href: '/hardware/balanzas-comerciales', icon: Scale },
      { name: '5. ESL / Flejes', href: '/hardware/esl', icon: Tag },
      { name: '6. Cartelería Digital', href: '/hardware/carteleria-digital', icon: Tv },
      { name: '7. Aeropuertos', href: '/hardware/aeropuertos', icon: Plane },
      { name: '8. Airport Charging', href: '/hardware/airport-charging', icon: BatteryCharging },
      { name: '9. Impresión', href: '/hardware/impresion', icon: Printer },
      { name: '10. Scanners & Handhelds', href: '/hardware/scanners', icon: Scan },
      { name: '11. PDA / Handheld', href: '/hardware/pda-handheld', icon: Smartphone },
      { name: '12. Periféricos', href: '/hardware/perifericos', icon: Cpu },
      { name: '13. Refurb', href: '/hardware/refurb', icon: RefreshCw },
      { name: '14. Servidores Lenovo', href: '/hardware/servidores-lenovo', icon: Server },
    ]
  },
  software: {
    label: 'Software',
    items: [
      { name: '1. Control Panel', href: '/software/control-panel', icon: LayoutDashboard, desc: 'Gestión de flota + monitoreo' },
      { name: '2. Analytics', href: '/software/analytics', icon: BarChart3, desc: 'KPIs y reportes' },
      { name: '3. CEO Cockpit™', href: '/software/ceo-cockpit', icon: Gauge, desc: 'Vista ejecutiva unificada' },
      { name: '4. C-Suite™', href: '/software/c-suite', icon: Briefcase, desc: 'Dashboard directivos' },
      { name: '5. Synkro', href: '/software/synkro', icon: RefreshCw, desc: 'Sincronización de datos' },
      { name: '6. BMS', href: '/software/bms', icon: Database, desc: 'Gestión de negocio' },
      { name: '7. Venddi', href: '/software/venddi', icon: ShoppingCart, desc: 'POS inteligente' },
    ]
  },
  ia: {
    label: 'IA',
    items: [
      { name: '0. IA Hub · Centro Neurálgico', href: '/ia-soluciones', icon: Zap, desc: 'Toda la IA de ALLCOM en un solo lugar' },
      { name: '1. ALLCOM IA', href: '/ia/allcom-ia', icon: Zap, desc: 'IA aplicada a tu operación' },
      { name: '2. Dashboards Ejecutivos', href: '/ia/dashboards-ejecutivos', icon: BarChart3, desc: 'Dashboards con inteligencia artificial' },
      { name: '3. Calculador de ROI', href: '/ia/calculador-de-roi', icon: Calculator, desc: 'Calcula tu retorno de inversión con IA' },
      { name: '4. Agentes IA', href: '/ia/agentes-ia', icon: Cpu, desc: 'Agentes inteligentes operacionales' },
      { name: '5. OpenClaw / Cowork', href: '/ia/openclaw', icon: Shrimp, desc: 'Agentes autónomos + colaboración IA' },
      { name: '6. Visual Experience (AVX)', href: '/soluciones/visual-experience', icon: Tv, desc: 'LED premium + inteligencia ALLCOM' },
    ]
  },
  servicios: {
    label: 'Servicios',
    items: [
      { name: '1. Soporte 24/7', href: '/servicios/soporte-24-7', icon: Headphones, desc: 'SLA + monitoreo + repuestos' },
      { name: '2. Programa Piloto', href: '/servicios/programa-piloto', icon: Rocket, desc: 'Prueba 30 días gratis sin costo' },
      { name: '3. Arriendo de Kioscos', href: '/servicios/arriendo-leasing', icon: CreditCard, desc: 'Eventos - fiestas' },
      { name: '4. Implementación & Obras', href: '/servicios/implementacion-obras', icon: Wrench, desc: 'Obras llave en mano' },
      { name: '5. Despliegues Masivos', href: '/servicios/despliegue-masivo', icon: MapPin, desc: 'Escala nacional' },
      { name: '6. Renovaciones Tecnológicas', href: '/servicios/renovaciones-tecnologicas', icon: RefreshCw, desc: 'Renovación masiva de equipamiento' },
      { name: '7. Obras Civiles', href: '/servicios/obras-civiles', icon: Hammer, desc: 'Adaptación de espacios comerciales' },
    ]
  },
  empresa: {
    label: 'Empresa',
    items: [
      { name: 'Nosotros', href: '/empresa/nosotros', icon: ShieldCheck, desc: 'Quiénes somos y qué hacemos' },
      { name: 'Equipo / Crew', href: '/empresa/equipo', icon: Users, desc: 'Líderes, ingenieros y técnicos' },
      { name: 'Historia', href: '/empresa/historia', icon: Clock, desc: '+20 años de trayectoria' },
      { name: 'Operación en Vivo', href: '/empresa/operacion-en-vivo', icon: Activity, desc: 'Monitoreo en tiempo real' },
      { name: 'Partners', href: '/empresa/partners', icon: Handshake, desc: 'Alianzas tecnológicas globales' },
      { name: 'Certificaciones', href: '/empresa/certificaciones', icon: Award, desc: 'Acreditaciones y calidad' },
      { name: 'Info. Corporativa', href: '/empresa/informacion-corporativa', icon: Scale, desc: 'Gobierno corporativo y compliance' },
      { name: 'Noticias', href: '/empresa/noticias', icon: Newspaper, desc: 'Novedades y actualizaciones' },
      { name: 'Releases & Roadmap', href: '/novedades', icon: Sparkles, desc: 'Lo último de la plataforma' },
    ]
  }
};

const AllcomLogo = ({ variant = 'dark', className = '' }) => {
  const location = useLocation();
  const isLanding = location.pathname === '/';
  const isFooter = variant === 'white';

  // Footer: siempre el wordmark blanco completo
  if (isFooter) {
    return (
      <Link
        to="/"
        className={`flex items-center ${className}`}
        data-testid="allcom-logo"
        aria-label="ALLCOM — Inicio"
      >
        <img
          src="/logo-white.png"
          alt="ALLCOM"
          className="h-10 lg:h-12 w-auto object-contain"
        />
      </Link>
    );
  }

  // Header: wordmark horizontal en todos los breakpoints
  // Mobile/tablet: archivo dedicado más fino y editorial
  // Desktop: wordmark estándar más grande
  return (
    <Link
      to="/"
      className={`flex items-center ${className}`}
      data-testid={isLanding ? 'allcom-logo-landing' : 'allcom-logo'}
      aria-label="ALLCOM — Inicio"
    >
      {/* Mobile/tablet: wordmark fino y elegante (h-3 = 50% del icono Menu h-6) */}
      <img
        src="/brand/allcom-logo-mobile.png"
        alt="ALLCOM"
        className="h-3 w-auto object-contain lg:hidden"
      />
      {/* Desktop ≥1024px: wordmark estándar */}
      <img
        src="/logo-dark.png"
        alt="ALLCOM"
        className={`hidden lg:block w-auto object-contain ${isLanding ? 'lg:h-16 xl:h-20' : 'lg:h-11 xl:h-12'}`}
      />
    </Link>
  );
};

const MegaMenuPanel = ({ section, onClose, activeCategorySlugs, dynamicItems }) => {
  const data = menuData[section];
  if (!data) return null;
  // For hardware menu: filter out categories with 0 products (no ghost content)
  // For other sections: show all items.
  let items = data.items;

  // Dynamic override: if backend provided live items for this section, use them.
  // This makes the menu reflect admin CRUD changes WITHOUT redeploy.
  if (dynamicItems && Array.isArray(dynamicItems) && dynamicItems.length > 0) {
    items = dynamicItems;
  }

  if (section === 'hardware' && activeCategorySlugs instanceof Set) {
    items = items.filter((it) => {
      // Extract category slug from href "/hardware/{slug}"
      const m = (it.href || '').match(/^\/hardware\/([^/?#]+)/);
      const slug = m && m[1];
      // If we can't parse, keep the item (defensive)
      return !slug || activeCategorySlugs.has(slug);
    });
  }
  // After filtering, renumber CONSECUTIVELY (1, 2, 3...) — only when dynamic items are used.
  // Static menuData items keep their literal labels.
  if (dynamicItems && Array.isArray(dynamicItems)) {
    items = items.map((it, i) => ({ ...it, name: `${i + 1}. ${it.name}` }));
  }
  return (
    <motion.div
      initial={{ opacity: 0, y: -8 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -8 }}
      transition={{ duration: 0.2 }}
      className="absolute top-full left-0 right-0 bg-white border-b border-slate-200 shadow-[0_30px_80px_rgba(2,6,23,0.12)] z-50"
      data-testid={`mega-menu-${section}`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2">
          {items.map((item) => {
            const Icon = item.icon;
            return (
              <Link
                key={item.href}
                to={item.href}
                onClick={onClose}
                className="flex items-start gap-3 p-3 rounded-xl hover:bg-slate-50 transition-colors group"
                data-testid={`menu-${section}-${(item.href || '').split('/').pop()}`}
              >
                {Icon && <Icon className="w-5 h-5 text-[#0EA5E9] mt-0.5 shrink-0" />}
                <div>
                  <div className="font-medium text-sm text-slate-900 group-hover:text-[#0EA5E9] transition-colors">{item.name}</div>
                  {item.desc && <div className="text-xs text-slate-500 mt-0.5">{item.desc}</div>}
                </div>
              </Link>
            );
          })}
        </div>
        <div className="mt-4 pt-4 border-t border-slate-100 flex items-center justify-between">
          <p className="text-sm text-slate-500">Tecnología en terreno, sin fricción</p>
          <div className="flex gap-3">
            <Link to="/casos" onClick={onClose} className="text-sm font-medium text-[#0EA5E9] hover:underline">Ver casos</Link>
            <Link to="/contacto" onClick={onClose} className="text-sm font-medium bg-[#0EA5E9] text-white px-4 py-1.5 rounded-lg hover:bg-sky-600 transition-colors">Agendar demo</Link>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export const Header = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [activeMenu, setActiveMenu] = useState(null);
  const [scrolled, setScrolled] = useState(false);
  const [activeCategorySlugs, setActiveCategorySlugs] = useState(null); // null = loading; Set when loaded
  const [dynamicHardware, setDynamicHardware] = useState(null); // null = use static menuData fallback
  const [dynamicSoluciones, setDynamicSoluciones] = useState(null);
  const location = useLocation();
  const cart = useCart();
  const cartCount = cart?.totalItems || 0;
  const openCart = () => cart?.setOpen(true);

  // Fetch active categories (non-empty) once, used to hide ghost links from the Hardware menu
  useEffect(() => {
    const url = `${process.env.REACT_APP_BACKEND_URL || ''}/api/products/categories`;
    fetch(url)
      .then(r => r.ok ? r.json() : [])
      .then(rows => {
        const set = new Set((rows || []).map(r => r.slug).filter(Boolean));
        setActiveCategorySlugs(set);
      })
      .catch(() => setActiveCategorySlugs(new Set())); // fail-soft: hide all hardware if fetch fails
  }, []);

  // Fetch DYNAMIC menu items from DB (hardware categories + solutions) so admin
  // CRUD changes show up without redeploy. On failure, falls back to static menuData.
  useEffect(() => {
    const base = process.env.REACT_APP_BACKEND_URL || '';

    fetch(`${base}/api/hardware/categories`)
      .then(r => r.ok ? r.json() : null)
      .then(rows => {
        if (!Array.isArray(rows) || rows.length === 0) return;
        const items = rows
          .slice()
          .sort((a, b) => (a.order ?? 999) - (b.order ?? 999))
          .map((c) => ({
            // Numbering happens AFTER hidden-filtering inside MegaMenuPanel,
            // so we don't prefix here. Store the raw name.
            name: c.name || c.slug,
            href: `/hardware/${c.slug}`,
            icon: resolveIcon(c.icon, Package),
            desc: c.description || '',
          }));
        setDynamicHardware(items);
      })
      .catch(() => { /* keep static fallback */ });

    fetch(`${base}/api/solutions`)
      .then(r => r.ok ? r.json() : null)
      .then(rows => {
        if (!Array.isArray(rows) || rows.length === 0) return;
        const items = rows
          .slice()
          .sort((a, b) => (a.order ?? a.display_order ?? 999) - (b.order ?? b.display_order ?? 999))
          .map((s) => ({
            name: s.title || s.name || s.slug,
            href: `/soluciones/${s.slug}`,
            icon: resolveIcon(s.icon, Monitor),
            desc: s.tagline || s.short_description || '',
          }));
        setDynamicSoluciones(items);
      })
      .catch(() => { /* keep static fallback */ });
  }, []);

  useEffect(() => {
    setMobileOpen(false);
    setActiveMenu(null);
  }, [location]);

  useEffect(() => {
    const handler = () => setScrolled(window.scrollY > 10);
    window.addEventListener('scroll', handler, { passive: true });
    return () => window.removeEventListener('scroll', handler);
  }, []);

  const sections = ['soluciones', 'hardware', 'software', 'ia', 'servicios'];
  const isLanding = location.pathname === '/';

  return (
    <>
    {/* Skip to main content - accessibility */}
    <a href="#main-content" className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-[100] focus:px-4 focus:py-2 focus:bg-[#0EA5E9] focus:text-white focus:rounded-lg focus:text-sm focus:font-semibold">
      Ir al contenido principal
    </a>
    <header
      data-testid="header"
      role="banner"
      className={`sticky top-0 z-50 transition-all duration-200 ${
        scrolled ? 'bg-white/90 backdrop-blur-lg border-b border-slate-200 shadow-sm' : 'bg-white border-b border-transparent'
      }`}
      onMouseLeave={() => setActiveMenu(null)}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className={`flex items-center justify-between ${isLanding ? 'h-14 lg:h-24' : 'h-14 lg:h-20'}`}>
          <AllcomLogo />

          {/* Desktop Nav */}
          <nav className="hidden lg:flex items-center gap-1" data-testid="desktop-nav">
            {sections.map((key) => (
              <button
                key={key}
                data-testid={`mega-menu-${key}-trigger`}
                onMouseEnter={() => setActiveMenu(key)}
                className={`flex items-center gap-1 px-3 py-2 text-sm font-medium rounded-lg transition-colors ${
                  activeMenu === key ? 'text-[#0EA5E9] bg-sky-50' : 'text-slate-700 hover:text-[#0EA5E9] hover:bg-slate-50'
                }`}
              >
                {menuData[key].label}
                <ChevronDown className="w-3.5 h-3.5" />
              </button>
            ))}
            <Link to="/casos" className="px-3 py-2 text-sm font-medium text-slate-700 hover:text-[#0EA5E9] rounded-lg hover:bg-slate-50 transition-colors">Casos</Link>
            <button
              onMouseEnter={() => setActiveMenu('empresa')}
              className={`flex items-center gap-1 px-3 py-2 text-sm font-medium rounded-lg transition-colors ${
                activeMenu === 'empresa' ? 'text-[#0EA5E9] bg-sky-50' : 'text-slate-700 hover:text-[#0EA5E9] hover:bg-slate-50'
              }`}
            >
              Empresa
              <ChevronDown className="w-3.5 h-3.5" />
            </button>
          </nav>

          {/* Desktop CTAs */}
          <div className="hidden lg:flex items-center gap-1.5">
            {/* Mi Cotización — icon only with badge (saves header space) */}
            <button
              type="button"
              onClick={openCart}
              className="relative flex items-center justify-center w-10 h-10 text-[#0A2540] hover:bg-slate-100 rounded-lg transition-colors"
              aria-label={`Mi cotización (${cartCount} ${cartCount === 1 ? 'producto' : 'productos'})`}
              title={`Mi cotización · ${cartCount} ${cartCount === 1 ? 'equipo' : 'equipos'}`}
              data-testid="header-cart-btn"
            >
              <ShoppingBag className="w-5 h-5" strokeWidth={1.6} />
              {cartCount > 0 && (
                <span
                  className="absolute -top-0.5 -right-0.5 min-w-[18px] h-[18px] px-1 flex items-center justify-center text-[10px] font-bold text-white bg-[#0EA5E9] rounded-full shadow-md tabular-nums"
                  data-testid="header-cart-badge"
                >
                  {cartCount > 99 ? '99+' : cartCount}
                </span>
              )}
            </button>
            {/* WhatsApp — solid brand logo */}
            <a
              href={`https://wa.me/${WHATSAPP_NUMBER}?text=Hola,%20necesito%20informaci%C3%B3n%20sobre%20sus%20soluciones`}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center w-10 h-10 text-emerald-600 hover:bg-emerald-50 rounded-lg transition-colors"
              aria-label="WhatsApp"
              title="WhatsApp ALLCOM"
              data-testid="header-whatsapp-button"
            >
              <WhatsAppIcon className="w-5 h-5" />
            </a>
            <Link
              to="/contacto"
              className="ml-1 flex items-center gap-2 px-5 py-2.5 text-sm font-semibold text-white bg-[#0EA5E9] rounded-xl hover:bg-sky-600 shadow-[0_10px_24px_rgba(2,6,23,0.12)] hover:-translate-y-px transition-all whitespace-nowrap"
              data-testid="header-primary-cta-button"
            >
              Cotizar / Agendar Demo
              <ArrowRight className="w-4 h-4" />
            </Link>
          </div>

          {/* Mobile actions — cart icon adjacent to hamburger */}
          <div className="flex items-center gap-1 lg:hidden" data-testid="mobile-actions">
            {/* Mobile cart icon (always visible alongside burger) */}
            <button
              type="button"
              onClick={openCart}
              className="relative p-2 rounded-lg hover:bg-slate-100"
              aria-label={`Mi cotización (${cartCount})`}
              data-testid="header-cart-btn-mobile"
            >
              <ShoppingBag className="w-5 h-5 text-[#0A2540]" strokeWidth={1.6} />
              {cartCount > 0 && (
                <span className="absolute -top-0.5 -right-0.5 min-w-[16px] h-[16px] px-0.5 flex items-center justify-center text-[9px] font-bold text-white bg-[#0EA5E9] rounded-full tabular-nums">
                  {cartCount > 99 ? '99+' : cartCount}
                </span>
              )}
            </button>

            {/* Mobile Menu Button */}
            <button
              className="p-2 rounded-lg hover:bg-slate-100"
              onClick={() => setMobileOpen(!mobileOpen)}
              data-testid="mobile-menu-button"
            >
              {mobileOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mega Menu Panel (Desktop) */}
      <AnimatePresence>
        {activeMenu && (
          <MegaMenuPanel
            section={activeMenu}
            onClose={() => setActiveMenu(null)}
            activeCategorySlugs={activeCategorySlugs}
            dynamicItems={
              activeMenu === 'hardware' ? dynamicHardware :
              activeMenu === 'soluciones' ? dynamicSoluciones :
              null
            }
          />
        )}
      </AnimatePresence>

      {/* Mobile Menu */}
      <AnimatePresence>
        {mobileOpen && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
            className="lg:hidden bg-white border-t border-slate-200 overflow-hidden"
          >
            <div className="max-h-[80vh] overflow-y-auto px-4 py-4 space-y-2">
              {Object.entries(menuData).map(([key, section]) => (
                <MobileMenuSection
                  key={key}
                  sectionKey={key}
                  section={section}
                  onClose={() => setMobileOpen(false)}
                  activeCategorySlugs={activeCategorySlugs}
                  dynamicItems={
                    key === 'hardware' ? dynamicHardware :
                    key === 'soluciones' ? dynamicSoluciones :
                    null
                  }
                />
              ))}
              <Link to="/casos" onClick={() => setMobileOpen(false)} className="block px-3 py-2.5 text-sm font-medium text-slate-700 hover:bg-slate-50 rounded-lg">Casos</Link>
              <div className="pt-3 border-t border-slate-100 space-y-2">
                <Link to="/contacto" onClick={() => setMobileOpen(false)} className="block w-full text-center px-5 py-3 text-sm font-semibold text-white bg-[#0EA5E9] rounded-xl">Cotizar / Agendar Demo</Link>
                <a href={`https://wa.me/${WHATSAPP_NUMBER}`} target="_blank" rel="noopener noreferrer" className="flex items-center justify-center gap-2 w-full px-5 py-3 text-sm font-medium text-emerald-600 bg-emerald-50 rounded-xl">
                  <WhatsAppIcon className="w-4 h-4" /> WhatsApp
                </a>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
    </>
  );
};

const MobileMenuSection = ({ section, onClose, activeCategorySlugs, sectionKey, dynamicItems }) => {
  const [open, setOpen] = useState(false);
  let items = section.items;

  // Dynamic override: use DB-backed items when provided (admin CRUD reflected immediately)
  if (dynamicItems && Array.isArray(dynamicItems) && dynamicItems.length > 0) {
    items = dynamicItems;
  }

  if (sectionKey === 'hardware' && activeCategorySlugs instanceof Set) {
    items = items.filter((it) => {
      const m = (it.href || '').match(/^\/hardware\/([^/?#]+)/);
      const slug = m && m[1];
      return !slug || activeCategorySlugs.has(slug);
    });
  }
  if (dynamicItems && Array.isArray(dynamicItems)) {
    items = items.map((it, i) => ({ ...it, name: `${i + 1}. ${it.name}` }));
  }
  return (
    <div>
      <button onClick={() => setOpen(!open)} className="flex items-center justify-between w-full px-3 py-2.5 text-sm font-medium text-slate-700 hover:bg-slate-50 rounded-lg">
        {section.label}
        <ChevronDown className={`w-4 h-4 transition-transform ${open ? 'rotate-180' : ''}`} />
      </button>
      {open && (
        <div className="ml-3 mt-1 space-y-0.5">
          {items.map((item) => (
            <Link key={item.href} to={item.href} onClick={onClose} className="block px-3 py-2 text-sm text-slate-600 hover:text-[#0EA5E9] hover:bg-slate-50 rounded-lg">{item.name}</Link>
          ))}
        </div>
      )}
    </div>
  );
};

export { AllcomLogo };
export default Header;
